import { h, Component } from 'preact';
import cx from 'classnames';
import { toDecimal } from '../../../../core/decimal';

interface CurrencyInputProps {
  disabled?: boolean;
  onValueChange: Function;
  fieldName: string;
  isInvalid?: boolean;

  extraClasses?: string; // use string over string[]
  isDisabled?: boolean;

  min?: number;

  placeholder?: string;
  value?: any;
}

interface CurrencyInputState {
  value?: any;
  errMessage?: string;
  displayValue?: string;
  isEditing?: boolean;
}

// Decided to create a component for this
// vs creating functions to do the swapping of view vs value
// Much cleaner and code stable with this way - J.Jover
export class CurrencyInput extends Component<CurrencyInputProps, CurrencyInputState> {
  constructor(props) {
    super(props);

    if (props.value) {
      this.setState({
        value: this.formatToCommaNotation(props.value),
        errMessage: ""
      });
    }
  }

  // componentWillReceiveProps(newProps: CurrencyInputProps) {
  //   if (newProps.value) {
  //     this.setState({
  //       value: this.formatToCommaNotation(newProps.value),
  //       // displayValue: `₱ ${this.formatToCommaNotation(newProps.value)}`
  //     });
  //   }
  // }

  formatToCommaNotation(value): string {
    let trimmed = Number.parseFloat(value).toFixed(2);
    let formatted = toDecimal(Number.parseFloat(trimmed));
    return formatted;
  }

  trimDecimals(value): number {
    let trimmed = Number.parseFloat(value).toFixed(2);
    let formatted = Number.parseFloat(trimmed);
    return formatted;
  }

  onChange = (e) => {
    const targetValue = e.target.value;

    this.setState({
      value: targetValue
    })
  }

  onFocus = (e) => {
    const val = this.state.value;
    this.setState({
      value: this.convertStringToFloat(val)
    })
  }

  onBlur = (e) => {
    const actual_value = this.state.value.toString();
    this.validateInput(actual_value);
  }

  convertStringToFloat(str: string) {
    if (!str) return;

    const compressed = str.split(',').join("");
    return parseFloat(compressed);
  }

  validateInput(input: string) {
    const trimmed = input.replace(',', "")
    const string_arr = trimmed.split("");

    string_arr.forEach(char => {
      if (isNaN(parseInt(char))) {
        this.setState({
          errMessage: "Enter a number",
          value: 0
        })
      } else {
        const final = this.formatToCommaNotation(trimmed)
        this.setState({
          errMessage: "",
          value: final
        })
        this.props.onValueChange(this.convertStringToFloat(final))
      }
    })
  }

  render(props: CurrencyInputProps, state: CurrencyInputState) {
    let errMsg = this.state.errMessage;

    return(
      <div>
        <div className="hi-currency-input input-group">
          <div className="input-group-prepend">
            <span
              id="peso-addon"
              className={ cx('input-group-text bg-white', {
                'invalid': props.isInvalid || errMsg !== ""
              }) }>₱</span>
          </div>
          <input
            disabled={props.disabled}
            className={ cx('form-control border-left-0',
              'hi-text-input',
              props.extraClasses, 
              { 'invalid': props.isInvalid || errMsg !== "" }
            )} 
            type="text"
            autocomplete="off"
            placeholder={props.placeholder}
            value={ this.state.value }
            onChange={ this.onChange }
            onBlur={ this.onBlur }
            onFocus={ this.onFocus }
            />
        </div>
        { errMsg && <p className="text-danger"> { errMsg } </p> }
      </div>
    );
  }
}